import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { StoreCommonService } from './../../../../../services/store/store-common.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-store-selection-table',
  templateUrl: './store-selection-table.component.html',
  styleUrls: ['./store-selection-table.component.css']
})
export class StoreSelectionTableComponent implements OnInit {

  paginationType = KontableComponent.ServerPagination;

  @Output() onStoreSelect: EventEmitter<any> = new EventEmitter();

  constructor(public storeCommonSvc: StoreCommonService) { }

  ngOnInit() {
  }

  selectStore(data) {
    this.onStoreSelect.emit(data);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-group/store-selection-table/store-selection-table.component.ts